export enum EvaluationRecordOutcomeStatus {
  Successful = "successful",
  Error = "error",
  Idle = "idle",
  Info = "info",
  Warning = "warning",
}
